import { LANGUAGES, t } from "../i18n";
import { useAuth } from "../AuthContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { Globe } from "lucide-react";

export default function LanguageSelector({ compact = false }) {
  const { lang, changeLang } = useAuth();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-selector-btn"
          className="flex items-center gap-2 bg-white border-2 border-slate-900/10 rounded-full px-3 py-2 text-sm font-bold text-slate-700 btn-squish"
        >
          <Globe size={18} strokeWidth={2.5} />
          {!compact && <span>{current.flag} {current.label}</span>}
          {compact && <span>{current.flag}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-2xl border-2 border-slate-900/10 max-h-[60vh] overflow-y-auto">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => changeLang(l.code)}
            className="text-base font-bold cursor-pointer rounded-xl"
          >
            <span className="mr-2">{l.flag}</span> {l.label}
            {l.code === lang && <span className="ml-auto text-sky-500">✓</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
